import styles from './index.scss'
import { Tabs } from 'antd-mobile'
import React, { useState } from 'react'
import { DpRichText } from '@/libs/components'

export type IDpBusinessCommodityRichView = {
  title?: string
  content?: string
  multiple?: boolean
  list?: {
    name: string
    value: string
  }[]
  styles?: React.CSSProperties
}

const RichView = (props: IDpBusinessCommodityRichView) => {
  const [activeKey, setActiveKey] = useState('0')
  return (
    <div className={styles['dp-business-commodity--rich']} style={props?.styles}>
      { props?.title &&  <div className={styles['dp-business-commodity--rich-title']}>{ props?.title }</div>}
      {props?.multiple ? (
        <Tabs
          activeKey={activeKey}
          onChange={(key: string) => setActiveKey(key)}
        >
          {props?.list?.map((item: any, index: number) => (
            <Tabs.Tab title={item.name} key={index}>
              <DpRichText data={item.value} />
            </Tabs.Tab>
          ))}
        </Tabs>
      ) : (
        <DpRichText data={props?.content} />
      )}
    </div>
  )
}

export default RichView
